import { render, staticRenderFns } from "./cost-detail.vue?vue&type=template&id=c04a16b6&lang=pug&"
import script from "./cost-detail.vue?vue&type=script&lang=js&"
export * from "./cost-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "~/lang/products/broadband?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230921151340%2Fcomponents%2Fproducts%2Fbroadband%2Fcost-detail.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports